import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import StaticPageHeaders from "../../../Components/StaticPageHeaders";
import TeamImg from "../../../Assets/Images/TeamQuote.png";
import "./sessionscheduled.css";
import { useLocation } from "react-router-dom";

const SessionScheduled = () => {
  const { state } = useLocation();
  const data = state?.data;

  const formatDay = (utcString) => {
    return new Date(utcString).toLocaleDateString("en-US", { weekday: "long" });
  };

  const formatDate = (utcString) => {
    return new Date(utcString).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const formatTime = (utcString) => {
    return new Date(utcString).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  if (!data) {
    return (
      <>
        <StaticPageHeaders title="Session Scheduled" />
        <div style={{ "--br-value": 1.28 }} className="bg-custom brightness">
          <div className="session-scheduled-page">
            <div className="scp-title">
              <h2 className="text-clip">No Session Details Found</h2>
              <p className="text-clip">
                It looks like you visited this page directly or the session
                details are missing.
              </p>
            </div>
            <div className="scp-gi-btns d-flex justify-content-center">
              <Link to="/" className="bg-orange btn">
                <span className="text-clip">Return To Home</span>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <StaticPageHeaders title="Session Scheduled" />
      <div style={{ "--br-value": 1.28 }} className="bg-custom brightness">
        <div className="session-scheduled-page">
          <div className="scp-title">
            <h2 className="text-clip">You’re All Set! See You in the gym</h2>
            <p className="text-clip">
              Get ready for an awesome session filled with customized
              instruction, focus, and skill development!
            </p>
          </div>

          <div className="scp-gi">
            <div className="scp-gi-cnt brightness">
              <h3>
                {data?.is_group_session === true
                  ? "Group Instructions"
                  : "One on One"}
              </h3>
              {data?.confirmed?.map((ses, index) => (
                <div className="scp-gi-dtls" key={index}>
                  <div className="gi-dtl-items">
                    <span className="text-clip">Location</span>
                    <p className="text-clip">
                      {ses.event_name} {", "} {ses.location}
                    </p>
                  </div>
                  <div className="gi-dtl-items">
                    <span className="text-clip">Day</span>
                    <p className="text-clip">{formatDay(ses.start_time_utc)}</p>
                  </div>
                  <div className="gi-dtl-items">
                    <span className="text-clip">Date</span>
                    <p className="text-clip">
                      {formatDate(ses.start_time_utc)}
                    </p>
                  </div>
                  <div className="gi-dtl-items">
                    <span className="text-clip">Time</span>
                    <p className="text-clip">
                      {formatTime(ses.start_time_utc)}
                    </p>
                  </div>
                </div>
              ))}

              {/* <h3 style={{marginTop: "20px"}}>{data?.is_group_session === true ? "Group Instructions" : "One on One"} (Skipped)</h3> */}

              {data?.skipped?.map((ses, index) => (
                <div className="scp-gi-dtls" key={index}>
                  <div className="gi-dtl-items">
                    <span className="text-clip">Location</span>
                    <p>{ses.event_name}</p>
                  </div>
                  <div className="gi-dtl-items">
                    <span className="text-clip">Reason</span>
                    <p>{ses.reason} </p>
                  </div>
                </div>
              ))}

              <hr />
              {data?.is_unlimited === false && (
                <div className="scp-gi-ftr">
                  <p className="text-clip">
                    {data?.confirmed?.length || 0} Sessions from your{" "}
                    {data?.is_group_session === true ? "Group" : "One on One"}{" "}
                    Instructions Package has been Deducted.
                  </p>
                  <p className="text-clip">
                    You have {data?.remaining_sessions} Sessions Remaining in
                    your{" "}
                    {data?.is_group_session === true ? "Group" : "One on One"}{" "}
                    Instructions Package.
                  </p>
                </div>
              )}
            </div>
            <div className="scp-gi-btns">
              <Link to="/profile/my-sessions" className="bg-orange btn">
                <span className="text-clip">View My Sessions</span>
              </Link>
              <Link to="/" className="bg-transparent btn">
                Return To Home
              </Link>
            </div>
          </div>

          <div className="gi-team-quote">
            <div className="gi-tq-cnt">
              <p className="text-clip">
                “We can’t wait to help your child take their basketball skills
                to the next level. Every shot, every drill, every smile — that’s
                what Shootin’ School is all about.”
              </p>
              <span>
                <span className="text-clip">– Team Shootin’ School</span> 🧡
              </span>
            </div>
            <div className="gi-tq-img">
              <img
                className="brightness"
                src={TeamImg}
                alt="Team Shootin School"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SessionScheduled;
